import React from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

export const TableComponent: MyComponentType<Props> = (props: Props) => {
  const { elements, id } = props;

  return (
    <div className="flex flex-col border-b border-gray-300 border-solid md:flex-row md:items-center" id={id}>
      <div className="text-lg my-4 flex flex-row md:flex-half md:items-center whitespace-pre-line pr-6">
        <props.ComponentBasicRender height="h-10" {...elements[0]} />
      </div>
      <span className="whitespace-pre-line">
        <props.ComponentBasicRender height="h-10" {...elements[1]} />
      </span>
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/TableComponentDefinition'));

TableComponent.definition = {
  id: ComponentIdEnum.TABLE_COMPONENT,
  name: '表格组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/CiF-FxjT1F_2FRLgG2NR0.png?image_process=resize,w_200',
  position: 12, // 显示顺序
  privateSchema: {
    // subContainersNumber: 2, // 会有几个子容器
    subContainersNode: [
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
        styles: {
          opacity: 1,
          fontSize: 18,
          lineHeight: '28px',
        },
        privateSchema: {
          text: 'Furniture features',
        },
      },
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
        styles: {
          opacity: 1,
          fontWeight: 400,
        },
        privateSchema: {
          text: '3 preset buttons control, 2 desk hooks, 1 cable management tray, Triple motor',
        },
      },
    ],
  }, // 组件自己的属性 不能通用的部分
  config: {},
  category: 'other',
  configForm: ConfigHOC(ConfigForm),
};
